export type ApiPageableRequestContructor = Omit<ApiPageableRequest, 'toServer'>;

export class ApiPageableRequest {
    pageNumber: number;
    pageSize: number;
    sort?: ApiSortRequest[];

    constructor(options: ApiPageableRequestContructor) {
        this.pageNumber = options.pageNumber;
        this.pageSize = options.pageSize;
        this.sort = options.sort;
    }

    toServer(): { pageNumber: number; pageSize: number; sort?: ApiSortRequest } {
        return {
            pageNumber: this.pageNumber - 1,
            pageSize: this.pageSize,
            sort: this.sort
                ? this.sort[0]
                : {
                      direction: 'ASC',
                      field: 'id'
                  }
        };
    }
}

export interface ApiSortRequest {
    direction: 'DESC' | 'ASC';
    field: string;
}
